import { Action } from '@ngrx/store';
import { IToastPayload } from './toast-payload.interface';

export class ToastsAction implements Action {

    public static toastError = '[Toasts] toast_error';
    public static toastErrorCompleted = '[Toasts] toast_error_completed';

    public static toastWarning = '[Toasts] toast_warning';
    public static toastWarningCompleted = '[Toasts] toast_warning_completed';

    public static toastSuccessMessage = '[Toasts] toast_success_message';
    public static toastSuccessMessageCompleted = '[Toasts] toast_success_message_completed'; 

    public static toastInfoMessage = '[Toasts] toast_info_message';
    public static toastInfoMessageCompleted = '[Toasts] toast_info_message_completed';

    public static toastMessageDisposed = '[Toasts] toast_message_disposed';

    constructor(
        public type: string,
        public payload: IToastPayload,
    ) {}

}
